import { gql } from "@apollo/client";

export const ES_ENFERMERO_CUIDADOR = gql`
query esEnfermeroCuidador($idVisita: Int!) {
    esEnfermeroCuidador(idVisita: $idVisita)
}`;

export default ES_ENFERMERO_CUIDADOR;